var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0526 0.538086H1.57895C0.710526 0.538086 0 1.35627 0 2.35627V15.0835H1.57895V2.35627H11.0526V0.538086ZM10.2632 4.17445H4.73684C3.86842 4.17445 3.16579 4.99263 3.16579 5.99263L3.15789 18.7199C3.15789 19.7199 3.86053 20.5381 4.72895 20.5381H13.4211C14.2895 20.5381 15 19.7199 15 18.7199V9.62899L10.2632 4.17445ZM4.73684 18.7199V5.99263H9.47368V10.5381H13.4211V18.7199H4.73684Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconLight);
export default __webpack_public_path__ + "static/media/copy-icon-light.1c3f1faca90f4429430c6b3e50ffd4cd.svg";
export { ForwardRef as ReactComponent };